import React, { useEffect, useState } from "react";
import baseUrl from "../../config/baseUrl";
import axios from "axios";
import {
  Card,
  CardContent,
  Box,
  Typography,
  TextField,
  Grid,
  Button,
  InputAdornment,
  IconButton,
  Drawer,
  Checkbox,
  Autocomplete,
  CircularProgress,
  MenuItem,
} from "@mui/material";
import SubMerchantTable from "./SubMerchantTable";
import CheckBoxOutlineBlankOutlinedIcon from "@mui/icons-material/CheckBoxOutlineBlankOutlined";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";

const icon = <CheckBoxOutlineBlankOutlinedIcon fontSize="small" />;
const checkedIcon = <CheckBoxOutlinedIcon fontSize="small" />;

const SubMerchant = ({ authCreate, authRead, authUpdate, authDelete }) => {
  const auth = sessionStorage.getItem("user");
  const [merchant, setMerchant] = useState([]);
  const [message, setMessage] = useState("");
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const ReadData = async () => {
    try {
      setLoading(true);
      let values = {
        page: page,
        limit: 10,
      };
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${auth}`,
        },
      };
      let result = await axios.post(`${baseUrl}/subMerchant`, values, config);
      setMessage(result.data.message.toUpperCase());
      setTotalPage(Number(result.data.totalPages));
      const fetchedData = result.data.data;
      setMerchant(fetchedData);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    ReadData();
  }, [page]);

  return (
    <>
      <Box>
        <Card variant="outlined">
          <CardContent>
            <Grid container spacing={2} alignItems="flex-start">
              {/* 1st Row */}
              <Grid item xs={6} sm={10}>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{
                    fontWeight: "bold",
                    color: "#1976d2",
                    fontSize: "1.2rem",
                    textTransform: "uppercase",
                    letterSpacing: 1,
                  }}
                >
                  SUBMERCHANT
                </Typography>
              </Grid>
              <Grid item xs={6} sm={2}>
                <AddSubMerchant />
              </Grid>
            </Grid>
            <Box
              sx={{
                overflow: {
                  xs: "auto",
                  sm: "unset",
                },
              }}
            >
              <SubMerchantTable
                merchant={merchant}
                message={message}
                page={page}
                totalPage={totalPage}
                setPage={setPage}
                auth={auth}
                ReadData={ReadData}
                authRead={authRead}
                authUpdate={authUpdate}
                authDelete={authDelete}
                loading={loading}
              />
            </Box>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

const AddSubMerchant = () => {
  const [state, setState] = useState({ right: false });
  const [currencyName, setCurrencyName] = useState([]);
  const [currencySettleName, setCurrencySettleName] = useState([]);
  const [fieldErrors, setFieldErrors] = useState({});
  const [selectedCurrencies, setSelectedCurrencies] = useState([]);
  const [selectedPayoutCurrencies, setSelectedPayoutCurrencies] = useState([]);
  const auth = sessionStorage.getItem("user");

  const [formState, setFormState] = useState({
    fname: "",
    lname: "",
    email: "",
    mobileno: "",
    settleCurrency: "",
    bname: "",
    blocation: "",
    jobtitle: "",
    website: "",
    apv: "",
    ata: "",
    chargebackPer: "",
  });

  const resetForm = () => {
    setFormState({
      fname: "",
      lname: "",
      email: "",
      mobileno: "",
      settleCurrency: "",
      bname: "",
      blocation: "",
      jobtitle: "",
      website: "",
      apv: "",
      ata: "",
      chargebackPer: "",
    });
    setSelectedCurrencies([]);
    setSelectedPayoutCurrencies([]);
    setFieldErrors({});
  };

  const toggleDrawer = (open) => () => {
    if (!open) resetForm();
    setState({ right: open });
  };

  useEffect(() => {
    if (state.right) {
      fetchCurrencyData();
      fetchSettleCurrencyData();
    }
  }, [state.right]);

  const fetchCurrencyData = async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${auth}`,
          "content-type": "multipart/form-data",
        },
      };
      const result = await axios.post(`${baseUrl}/countrySelect`, {}, config);
      setCurrencyName(result.data.result || []);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchSettleCurrencyData = async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${auth}`,
          "content-type": "multipart/form-data",
        },
      };
      const result = await axios.post(`${baseUrl}/settleCurrencyList`, {}, config);
      setCurrencySettleName(result.data.result || []);
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = {};
    if (!formState.fname) errors.fname = "First Name is required";
    if (!formState.lname) errors.lname = "Last Name is required";
    if (!formState.email) errors.email = "Email is required";
    if (!formState.mobileno) errors.mobileno = "Mobile Number is required";
    if (!formState.settleCurrency)
      errors.settleCurrency = "Settle Currency is required";
    if (!selectedCurrencies.length)
      errors.selectedCurrencies =
        "Please select at least one Solution Currency";
    if (!selectedPayoutCurrencies.length)
      errors.payoutCurrencies = "Please select at least one Payout Currency";

    setFieldErrors(errors);

    if (Object.keys(errors).length > 0) return;

    try {
      const payload = {
        ...formState,
        solutions: selectedCurrencies.map((c) => c.value),
        payouts: selectedPayoutCurrencies.map((c) => c.value),
      };

      const config = {
        headers: {
          Authorization: `Bearer ${auth}`,
          "Content-Type": "application/json",
        },
      };

      const result = await axios.post(
        `${baseUrl}/createMerchant`,
        payload,
        config
      );

      if (result.status === 200) {
        alert(result.data.message);
        toggleDrawer(false)();
        window.location.reload();
      } else {
        const msg =
          result.data.message || "Server error. Please try again later.";
        if (msg.toLowerCase().includes("email already exists")) {
          setFieldErrors({
            email: msg || "Email already exists",
          });
          return;
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const RequiredLabel = ({ label }) => (
    <span style={{ fontWeight: 500 }}>
      <span style={{ color: "red" }}>*</span> {label}
    </span>
  );

  const renderCurrencySelect = (label, value, setValue) => (
    <Autocomplete
      multiple
      disableCloseOnSelect
      options={currencyName}
      getOptionLabel={(option) => option.label}
      value={value}
      onChange={(_, newValue) => setValue(newValue)}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox checked={selected} style={{ marginRight: 8 }} />
          {option.label}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={<RequiredLabel label={label} />}
          variant="outlined"
        />
      )}
      fullWidth
    />
  );

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        sx={{ float: "inline-end" }}
        onClick={toggleDrawer(true)}
      >
        ADD
      </Button>
      <Drawer anchor="right" open={state.right} onClose={toggleDrawer(false)}>
        <Box sx={{ width: { xs: 300, sm: 600 }, p: 3 }}>
          <form onSubmit={handleSubmit}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 2,
              }}
            >
              <h4 style={{ margin: 0 }}>ADD SUBMERCHANT</h4>
              <Button
                onClick={toggleDrawer(false)}
                sx={{
                  minWidth: 0,
                  padding: "6px",
                  backgroundColor: "#ff6600",
                  borderRadius: "50%",
                  color: "#fff",
                  "&:hover": { backgroundColor: "#e65c00" },
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </Button>
            </Box>

            <Typography variant="caption" sx={{ color: "red" }}>
              * These fields are required to proceed
            </Typography>

            <Grid container spacing={2} sx={{ marginTop: 0.5 }}>
              {[
                { label: "First Name", name: "fname" },
                { label: "Last Name", name: "lname" },
                { label: "Email", name: "email" },
                { label: "Mobile No.", name: "mobileno" },
                { label: "Business Name", name: "bname" },
                { label: "Business Location", name: "blocation" },
                { label: "Job Title", name: "jobtitle" },
                { label: "Website", name: "website" },
                { label: "Annual Processing Volume", name: "apv" },
                { label: "Average Transaction Amount", name: "ata" },
                { label: "Chargeback %", name: "chargebackPer" },
              ].map(({ label, name }) => (
                <Grid item xs={12} sm={6} key={name}>
                  <Box sx={{ minHeight: 60 }}>
                    <Typography
                      variant="caption"
                      sx={{ color: "red", mb: 0.5, minHeight: "18px" }}
                    >
                      {fieldErrors[name] || " "}
                    </Typography>
                    <TextField
                      fullWidth
                      variant="outlined"
                      label={
                        ["fname", "lname", "email", "mobileno"].includes(
                          name
                        ) ? (
                          <RequiredLabel label={label} />
                        ) : (
                          label
                        )
                      }
                      name={name}
                      value={formState[name]}
                      onChange={handleChange}
                      error={Boolean(fieldErrors[name])}
                    />
                  </Box>
                </Grid>
              ))}

              <Grid item xs={12} md={6}>
                {fieldErrors.settleCurrency && (
                  <Typography variant="caption" sx={{ color: "red", mb: 0.5 }}>
                    {fieldErrors.settleCurrency}
                  </Typography>
                )}
                <TextField
                  fullWidth
                  select
                  label={<RequiredLabel label="Settle Currency" />}
                  name="settleCurrency"
                  value={formState.settleCurrency}
                  onChange={handleChange}
                  variant="outlined"
                >
                  {currencySettleName.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12}>
                {fieldErrors.selectedCurrencies && (
                  <Typography variant="caption" sx={{ color: "red", mb: 0.5 }}>
                    {fieldErrors.selectedCurrencies}
                  </Typography>
                )}
                {renderCurrencySelect(
                  "Solution Apply Currencies",
                  selectedCurrencies,
                  setSelectedCurrencies
                )}
              </Grid>

              <Grid item xs={12}>
                {fieldErrors.payoutCurrencies && (
                  <Typography variant="caption" sx={{ color: "red", mb: 0.5 }}>
                    {fieldErrors.payoutCurrencies}
                  </Typography>
                )}
                {renderCurrencySelect(
                  "Payout Currencies",
                  selectedPayoutCurrencies,
                  setSelectedPayoutCurrencies
                )}
              </Grid>

              <Grid item xs={12} textAlign="right">
                <Button type="submit" variant="contained">
                  Create
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Drawer>
    </>
  );
};

export default SubMerchant;
